/* Versioned, portable links: only explicit maker settings are shared. */
window.ranchMakerShare = function ({kind, anchor, read, restore}) {
  const group = document.createElement('div');
  group.className = 'maker-share';
  const share = document.createElement('button'), copy = document.createElement('button');
  const status = document.createElement('p');
  share.type = copy.type = 'button';
  share.textContent = 'Share'; copy.textContent = 'Copy link';
  share.setAttribute('aria-label', 'Share your ' + kind);
  copy.setAttribute('aria-label', 'Copy link to your ' + kind);
  status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite');
  status.textContent = 'Share a link to this exact creation.';
  group.append(share, copy, status); anchor.after(group);
  function link() {
    const bytes = new TextEncoder().encode(JSON.stringify({v:1,kind,state:read()}));
    const encoded = btoa(Array.from(bytes, b => String.fromCharCode(b)).join(''))
      .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    const url = new URL(location.origin + location.pathname);
    url.searchParams.set('creation', encoded);
    return url.href;
  }
  async function copyLink(url) {
    try {
      await navigator.clipboard.writeText(url);
      status.textContent = 'Link copied! Anyone with it can open this creation.';
    } catch {
      let field = group.querySelector('input');
      if (!field) {
        field = document.createElement('input'); field.readOnly = true;
        field.setAttribute('aria-label', 'Creation link — select and copy'); group.append(field);
      }
      field.value = url; field.focus(); field.select();
      status.textContent = 'Select and copy the link below.';
    }
  }
  copy.addEventListener('click', () => copyLink(link()));
  share.addEventListener('click', async () => {
    const url = link();
    if (!navigator.share) { await copyLink(url); return; }
    try {
      await navigator.share({title:'My Ranch Bowl ' + kind, text:'Check out my creation, then make your own.', url});
      status.textContent = 'Share menu opened.';
    } catch (error) {
      if (error.name !== 'AbortError') await copyLink(url);
    }
  });
  try {
    const encoded = new URL(location.href).searchParams.get('creation');
    if (encoded) {
      if (encoded.length > 32000) throw new Error('Link too long');
      const base64 = encoded.replace(/-/g, '+').replace(/_/g, '/');
      const parsed = JSON.parse(new TextDecoder('utf-8', {fatal:true}).decode(
        Uint8Array.from(atob(base64), ch => ch.charCodeAt(0))));
      if (parsed.v !== 1 || parsed.kind !== kind || !parsed.state || typeof parsed.state !== 'object') throw new Error('Invalid creation');
      restore(parsed.state);
      status.textContent = 'Shared creation loaded. Make it your own or share it again.';
    }
  } catch {
    status.textContent = 'This shared link could not be loaded. You can still make your own.';
  }
};
